var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCc = function SvgIconCc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.42 17.218.33.689.744-.172-.333.687.598.474-.745.168.002.763-.595-.478-.595.478.002-.764-.745-.167.598-.474-.333-.687.744.172zM15.357 9.912l.33.689.743-.172-.333.687.598.474-.744.168.002.763-.596-.477-.595.477.002-.763-.744-.168.598-.474-.334-.687.744.172zM18.42 5.739l.33.688.744-.172-.333.687.598.474-.745.168.002.763-.595-.477-.596.477.003-.763-.745-.168.598-.474-.333-.687.744.172zM21.098 8.87l.329.689.744-.172-.333.687.598.474-.745.168.002.763-.595-.477-.596.477.002-.763-.744-.168.598-.474-.333-.687.743.172zM19.184 12.521l.26.797h.837l-.678.493.26.797-.679-.492-.678.492.259-.797-.678-.493h.838z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.305 15.391a3.391 3.391 0 1 1 1.613-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.613.408M7.547 4.696a2.086 2.086 0 0 0-3.614 0zM7.553 4.708 5.74 6.522 3.925 4.708a2.087 2.087 0 1 0 3.628 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M5.218 6v1.76a2.1 2.1 0 0 0 1.043 0V6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCc;